import React from 'react'
import { Timeline, TimelinePermissions } from '../../../services/api'
import { UsersIcon, DocumentTextIcon, PencilSquareIcon } from '@heroicons/react/24/outline'

const permissionLabels: Record<TimelinePermissions, string> = {
  [TimelinePermissions.Read]: 'Odczyt',
  [TimelinePermissions.Self]: 'Własne',
  [TimelinePermissions.Write]: 'Edycja',
  [TimelinePermissions.Delete]: 'Usuwanie',
  [TimelinePermissions.Maintainer]: 'Zarządzanie',
  [TimelinePermissions.Owner]: 'Właściciel',
}

export interface TimelineCardProps {
  timeline: Timeline
  width?: number
  tabIndex?: number
  onClick?: () => void
}

export const TimelineCard: React.FC<TimelineCardProps> = ({ timeline, width, tabIndex, onClick }) => {
  const coverUrl = timeline.cover_photo?.urls?.small

  const permissionLabel = permissionLabels[timeline.permissions] || 'Odczyt'

  return (
    <button
      onClick={onClick}
      style={width ? { width } : undefined}
      tabIndex={tabIndex}
      className="group flex flex-col overflow-hidden rounded-lg border border-gray-200 bg-white transition-all duration-300 hover:shadow-md hover:scale-[1.01] focus:outline-none focus:ring-2 focus:ring-indigo-500 text-left w-full"
    >
      {/* Cover image — square */}
      <div
        className="relative aspect-square w-full overflow-hidden"
        style={{ backgroundColor: coverUrl ? undefined : (timeline.color || '#e5e7eb') }}
      >
        {coverUrl && (
          <img
            src={coverUrl}
            alt={timeline.name}
            className="h-full w-full object-cover"
          />
        )}
      </div>

      {/* Content */}
      <div className="flex flex-col gap-1.5 p-3">
        {/* Title */}
        <h3 className="text-sm font-semibold text-gray-900 line-clamp-1">
          {timeline.name}
        </h3>

        {/* Description */}
        {timeline.description && (
          <p className="text-xs text-gray-500">
            {timeline.description}
          </p>
        )}

        {/* Stats row */}
        <div className="flex flex-wrap items-center gap-1.5 mt-1">
          <div className="flex items-center gap-1 rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-600">
            <UsersIcon className="h-3 w-3" />
            <span>{timeline.editors_count}</span>
          </div>

          <div className="flex items-center gap-1 rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-600">
            <DocumentTextIcon className="h-3 w-3" />
            <span>{timeline.posts_count}</span>
          </div>

          <div className="flex items-center gap-1 rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-600">
            <PencilSquareIcon className="h-3 w-3" />
            <span>{permissionLabel}</span>
          </div>
        </div>
      </div>
    </button>
  )
}
